import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConsultaCadin } from './consulta-cadin.model';

export interface ResultadoPaginadoConsultaCadin {
  resultados: ConsultaCadin[];
  totalRegistrosSemPaginacao: number;
}

@Injectable({ providedIn: 'root' })
export class ConsultaCadinService {

  // A modalidade (FGBS/PEAC/FGT) e injetada automaticamente pelo interceptor
  // (modalidade-filler-interceptor), transformando 'rest/front/consulta-cadin'
  // em 'rest/front/{modalidade}/consulta-cadin'.
  // Path SEM /public/ para que a seguranca por role (@RolesAllowed) seja aplicada.
  // Casa com o @Path("/front/{idModalidadeGarantia}/consulta-cadin") da FrontApi.
  private readonly baseUrl = 'rest/front/consulta-cadin';

  constructor(private http: HttpClient) { }

  consultar(params: { cnpj?: string; impedimento?: string; pagina?: number; limite?: number; })
    : Observable<ResultadoPaginadoConsultaCadin> {
    let httpParams = new HttpParams();
    if (params.cnpj) { httpParams = httpParams.set('cnpj', params.cnpj); }
    if (params.impedimento) { httpParams = httpParams.set('impedimento', params.impedimento); }
    if (params.pagina != null) { httpParams = httpParams.set('pagina', String(params.pagina)); }
    if (params.limite != null) { httpParams = httpParams.set('limite', String(params.limite)); }
    return this.http.get<ResultadoPaginadoConsultaCadin>(this.baseUrl, { params: httpParams });
  }
}
